import { Field, type FieldInputProps } from "@ark-ui/react";
import clsx from "clsx";
import * as React from "react";

interface BaseInputProps extends Omit<FieldInputProps, "size"> {
  size?: "xs" | "sm" | "md" | "lg";
  variant?: "underline" | "outline";
  type?: "text" | "password" | "email" | "url" | "number" | "search";
  unstyled?: boolean;
  error?: boolean;
}

const BaseInput = React.forwardRef<React.ElementRef<"input">, BaseInputProps>(
  (props, ref) => {
    const {
      size = "md",
      className,
      variant = "outline",
      error,
      type = "text",
      unstyled = false,
      ...rest
    } = props;

    return (
      <Field.Input
        ref={ref}
        type={type}
        data-variant={variant}
        data-invalid={error ? "true" : "false"}
        data-size={size}
        className={clsx(
          "ox-reset ",
          !unstyled && "ox-Input",
          !unstyled && size === "xs"
            ? "ox-fz-xs"
            : size === "sm"
              ? "ox-fz-sm"
              : size === "md"
                ? "ox-fz-md"
                : size === "lg"
                  ? "ox-fz-lg"
                  : "",
          className,
        )}
        {...rest}
      />
    );
  },
);

export { BaseInput };
export type { BaseInputProps };
